import { Stack } from "@mui/material";
import {
    Feed as FeedIcon,
    Forum as ForumIcon,
    Notifications as NotificationsIcon,
    People,
} from "@mui/icons-material";
import { Event as EventIcon } from "@mui/icons-material";
import React from "react";
import NavIconButton from "./NavIconButton";
import ProfileAvatarButton from "./ProfileAvatarButton";

type Props = {
    isAuthenticated: boolean;
    initialSetupComplete: boolean;
    unreadMessageCount: number;
    unreadOtherCount: number;
    profilePhoto?: string | null;
    userFirstName?: string | null;
    open: boolean;
    handleProfileMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function TopNavActions({
    isAuthenticated,
    initialSetupComplete,
    unreadMessageCount,
    unreadOtherCount,
    profilePhoto,
    userFirstName,
    open,
    handleProfileMenuOpen,
}: Props) {
    if (!isAuthenticated || !initialSetupComplete) return null;

    return (
        <Stack direction="row" spacing={2} alignItems="center">
            <NavIconButton
                to="/newsfeed"
                tooltip="Newsfeed"
                icon={<FeedIcon />}
                text="Newsfeed"
                ariaLabel="Go to newsfeed"
            />
            <NavIconButton
                to="/events"
                tooltip="Events"
                icon={<EventIcon />}
                text="Events"
                ariaLabel="Go to events"
            />
            <NavIconButton
                to="/messaging"
                tooltip="Messages"
                icon={<ForumIcon />}
                text="Messages"
                badgeContent={unreadMessageCount}
                ariaLabel="Go to messages"
            />
            <NavIconButton
                to="/notifications"
                tooltip="Notifications"
                icon={<NotificationsIcon />}
                text="Notifications"
                badgeContent={unreadOtherCount}
                ariaLabel="Go to notifications"
            />
            <NavIconButton
                to="/people"
                tooltip="User Directory"
                icon={<People />}
                text="Directory"
                ariaLabel="Go to user directory"
            />
            <ProfileAvatarButton
                photoUrl={profilePhoto}
                firstName={userFirstName}
                open={open}
                onClick={(event) => handleProfileMenuOpen(event)}
            />
        </Stack>
    );
}
